<button
  type="button"
  class="min-w-0 w-full flex gap-2 rounded-lg transition py-3 shadow-sm justify-center font-medium font-title"
  [ngClass]="
    className() + ' ' +
    sizeClasses() + ' ' +
    variantClasses() + ' ' +
    disabledClasses()
  "
  [disabled]="disabled() || loading()"
  (click)="onClick($event)"
>
  @if (!loading()) {
    @if (startIcon()) {
      <lib-icon [name]="startIcon()!" class="text-gray-400 min-w-5 min-h-5 size-5" [class]="iconClass()"></lib-icon>
    }
    <ng-content></ng-content>
    @if (endIcon()) {
      <lib-icon [name]="endIcon()!" class="text-gray-400 min-w-5 min-h-5 size-5" [class]="iconClass()"></lib-icon>
    }
  }
  @else {
    <span class="animate-spin">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          opacity="0.5"
          cx="10"
          cy="10"
          r="8.75"
          stroke="white"
          stroke-width="2.5"
        />
        <mask id="path-2-inside-1_3755_26472" fill="white">
          <path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" />
        </mask>
        <path
          d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"
          stroke="white"
          stroke-width="4"
          mask="url(#path-2-inside-1_3755_26472)"
        />
      </svg>
    </span>
    Cargando...
  }
</button>

